export const removeActivePrefix = (str?: string) => {
  return str?.replace(/active:\s*/, '');
};
